class ComparisonSlider extends HTMLElement {
	connectedCallback() {
		this.sliderOverlay = this.querySelector('.comparison-slider__overlay');
		this.sliderLine = this.querySelector('.comparison-slider__line');
		this.sliderInput = this.querySelector('.comparison-slider__input');

		if (!this.sliderOverlay || !this.sliderLine || !this.sliderInput || this.boundHandleChange) return;

		this.boundHandleChange = this.handleChange.bind(this);
		this.sliderInput.addEventListener('input', this.boundHandleChange);
		window.addEventListener('resize', this.boundHandleChange);
		this.updateImageWidth();
		this.handleChange({ currentTarget: this.sliderInput });
	}

	disconnectedCallback() {
		if (this.sliderInput && this.boundHandleChange) {
			this.sliderInput.removeEventListener('input', this.boundHandleChange);
			window.removeEventListener('resize', this.boundHandleChange);
		}
	}

	updateImageWidth() {
		const overlayImage = this.sliderOverlay.querySelector('img');
		if (!overlayImage || !this.offsetWidth) return;

		overlayImage.style.width = `${this.offsetWidth}px`;
	}

	handleChange(event) {
		const value = this.sliderInput.value;
		this.updateImageWidth();
		this.sliderOverlay.style.width = `${value}%`;
		this.sliderLine.style.left = `${value}%`;
	}
}

if (!customElements.get('comparison-slider')) {
	customElements.define('comparison-slider', ComparisonSlider);
}
